<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">默认值</nz-form-label>
  <nz-form-control>
    <nz-input-number
      #nameInput="ngModel"
      name="value"
      type="number"
      [(ngModel)]="config.value"
      [nzPrecision]="0"
      nzPrecisionMode="cut"
      style="width: 100%"
    ></nz-input-number>
  </nz-form-control>
</nz-form-item>
<!-- 校验方式 -->
<nz-form-item *ngIf="config">
  <nz-form-label [nzSpan]="6">校验方式</nz-form-label>
  <nz-form-control>
    <nz-radio-group name="validationRuleType" [(ngModel)]="config.ruleType" (ngModelChange)="typeChange($event)" style="width: 100%">
      <label nz-radio nzValue="Limit">上下限</label>
      <label nz-radio nzValue="Effective">有效值</label>
    </nz-radio-group>
  </nz-form-control>
</nz-form-item>

<!-- 是否显示上下限 -->
<nz-form-item *ngIf="rule == ruleType.Limit">
  <nz-form-label [nzSpan]="6">是否显示上下限</nz-form-label>
  <nz-form-control>
    <label nz-checkbox #editionNameInput="ngModel" name="DisplayLimits" [(ngModel)]="config.displayLimits"></label>
  </nz-form-control>
</nz-form-item>

<!-- 是否允许超上下限 -->
<nz-form-item *ngIf="rule == ruleType.Limit">
  <nz-form-label [nzSpan]="6">是否允许超上下限</nz-form-label>
  <nz-form-control>
    <label nz-checkbox #editionNameInput="ngModel" name="IsLimitOverrideAllowed" [(ngModel)]="config.isLimitOverrideAllowed"></label>
  </nz-form-control>
</nz-form-item>

<!-- 下限 -->
<nz-form-item *ngIf="rule == ruleType.Limit">
  <nz-form-label [nzSpan]="6">下限</nz-form-label>
  <nz-form-control>
    <nz-input-number
      class="labelStyle"
      #editionNameInput="ngModel"
      [nzStep]="1"
      name="LowerLimit"
      [nzMax]="config.upperLimit"
      [(ngModel)]="config.lowerLimit"
    ></nz-input-number>
  </nz-form-control>
</nz-form-item>

<!-- 上限 -->
<nz-form-item *ngIf="rule == ruleType.Limit">
  <nz-form-label [nzSpan]="6">上限 </nz-form-label>
  <nz-form-control>
    <nz-input-number
      class="labelStyle"
      #editionNameInput="ngModel"
      [nzStep]="1"
      [nzMin]="config.lowerLimit"
      name="UpperLimit"
      [(ngModel)]="config.upperLimit"
    ></nz-input-number>
  </nz-form-control>
</nz-form-item>

<!-- 有效值 -->
<nz-form-item *ngIf="rule == ruleType.Effective">
  <nz-form-label [nzSpan]="6">有效值</nz-form-label>
  <nz-form-control>
    <app-tags-select name="effectiveSelect" ngDefaultControl [dataType]="config.dataType" [(ngModel)]="config.effective"></app-tags-select>
  </nz-form-control>
</nz-form-item>
